import { useEffect, useRef } from 'react';

interface ShortcutHandlers {
  onRefresh: () => void;
  onFocusSearch: () => void;
  onClearSearch: () => void;
}

function isEditingElement(): boolean {
  const el = document.activeElement;
  if (!el) return false;
  const tag = el.tagName.toLowerCase();
  return tag === 'input' || tag === 'textarea' || tag === 'select' || (el as HTMLElement).isContentEditable;
}

export function useKeyboardShortcuts(handlers: ShortcutHandlers): void {
  const ref = useRef(handlers);
  ref.current = handlers;

  useEffect(() => {
    function handle(e: KeyboardEvent) {
      if (isEditingElement()) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;

      if (e.key === 'r' || e.key === 'R') {
        e.preventDefault();
        ref.current.onRefresh();
      } else if (e.key === '/') {
        e.preventDefault();
        ref.current.onFocusSearch();
      } else if (e.key === 'Escape') {
        ref.current.onClearSearch();
      }
    }
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, []);
}
